import Footer from "../../FrontPage/components/Footer/Footer";
import Header from "../../FrontPage/components/Header/Header";
import ForgotPasswordForm from "../component/ForgotPassword/ForgotPassword";
const ForgotPassword = () => {
  return (
    <div>
      <Header />
      <ForgotPasswordForm />
      <Footer />
    </div>
  );
};

export default ForgotPassword;
